import React, { useEffect, useRef } from 'react'
import * as Plot from '@observablehq/plot'
import { PlotOptions } from '@observablehq/plot'
import { MacroKcalDistribution } from '@/api/types'

type Props = {
  data: MacroKcalDistribution[]
  options?: PlotOptions
}

const PROTEIN = 'Protein'
const FAT = 'Fat'
const CARBOHYDRATES = 'Carbohydrates'

export default function HistogramMacroDistribution({ data, options }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (data === undefined) return
    const plot = Plot.plot({
      color: {
        legend: true,
        domain: [CARBOHYDRATES, PROTEIN, FAT],
        range: ['var(--color__carbs)', 'var(--color__protein)', 'var(--color__fat)'],
      },
      marks: [
        Plot.ruleY([0]),
        Plot.axisX({
          label: '% Calories',
          lineWidth: 8,
          fontSize: '1rem',
          labelOffset: 35,
          marginBottom: 40,
        }),
        Plot.axisY({ label: 'Recipes Count', lineWidth: 8, fontSize: '1rem' }),
        Plot.line(
          data,
          Plot.binX(
            { y: 'count', filter: null },
            {
              x: (x: MacroKcalDistribution) =>
                (x.carbohydratesKcal / (x.carbohydratesKcal + x.fatKcal + x.proteinKcal)) * 100,
              domain: [0, 100],
              thresholds: 'freedman-diaconis',
              stroke: () => CARBOHYDRATES,
            },
          ),
        ),
        Plot.line(
          data,
          Plot.binX(
            { y: 'count', filter: null },
            {
              x: (x: MacroKcalDistribution) =>
                (x.proteinKcal / (x.carbohydratesKcal + x.fatKcal + x.proteinKcal)) * 100,
              domain: [0, 100],
              thresholds: 20,
              stroke: () => PROTEIN,
            },
          ),
        ),
        Plot.line(
          data,
          Plot.binX(
            { y: 'count', filter: null },
            {
              x: (x: MacroKcalDistribution) =>
                (x.fatKcal / (x.carbohydratesKcal + x.fatKcal + x.proteinKcal)) * 100,
              domain: [0, 100],
              thresholds: 20,
              stroke: (x) => FAT,
            },
          ),
        ),
      ],
      ...options,
    })

    if (containerRef?.current) {
      containerRef.current.append(plot)
    }

    return () => plot.remove()
  }, [data])

  return <div ref={containerRef} />
}
